import { useEffect } from 'react';

export default function useComposerAbortHotkey({ loading = false, submitting = false, onAbort } = {}) {
  useEffect(() => {
    const canBindAbort = [loading, submitting].some(Boolean)
      && typeof onAbort === 'function'
      && typeof window !== 'undefined';
    if (!canBindAbort) {
      return undefined;
    }
    const handleAbortEscape = (event) => {
      const shouldIgnore = [
        event?.key !== 'Escape',
        event?.ctrlKey,
        event?.metaKey,
        event?.altKey,
      ].some(Boolean);
      if (shouldIgnore) {
        return;
      }
      event.preventDefault();
      event.stopPropagation();
      onAbort();
    };
    window.addEventListener('keydown', handleAbortEscape, true);
    return () => window.removeEventListener('keydown', handleAbortEscape, true);
  }, [loading, submitting, onAbort]);
}
